import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Hidden, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Document_FieldsFragment, Document_UploadFileMutation, SignatureType } from 'queries';

import DocumentUploadModal from 'pages/common/document/document-upload-modal';
import MailDocumentModal from 'pages/common/document/mail-document-modal';
import { NotificationSeverity, showToast } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: '#1C2541',
    color: '#FFFFFF',
    borderRadius: '24px',
    boxShadow: 'none',
    fontSize: '12px',
    px: '16px',
    width: '120px',
  },
}));

type Props = {
  document: Document_FieldsFragment;
  onRefreshDocuments: () => void;
};

const ResolveDocumentForSignatureButton = ({ document, onRefreshDocuments }: Props) => {
  const classes = useStyles();
  const { portalId } = useParams<Record<string, string>>();
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showMailDocumentModal, setShowMaiDocumentModal] = useState(false);

  const mailingRequired = [
    SignatureType.PhysicalSignatureAndNotaryMailRequired,
    SignatureType.PhysicalSignatureMailRequired,
  ].includes(document.signatureType);

  const handleUploadComplete = async (_: Document_UploadFileMutation) => {
    showToast({
      message: 'Document uploaded successfully',
      severity: NotificationSeverity.SUCCESS,
    });
    setShowUploadModal(false);
    onRefreshDocuments();
  };

  const openModal = () => {
    if (mailingRequired) {
      setShowMaiDocumentModal(true);
    } else {
      setShowUploadModal(true);
    }
  };

  return (
    <div>
      <Button
        component="span"
        className={classes.button}
        color="primary"
        variant="contained"
        size="small"
        onClick={openModal}
      >
        <Hidden mdDown>
          <Typography>{mailingRequired ? 'Sign & Mail' : 'Upload'}</Typography>
        </Hidden>
      </Button>
      {document.parent?.id && (
        <DocumentUploadModal
          documentTagId={document.documentTagId}
          title="Upload Signed Document"
          showModal={showUploadModal}
          setShowModal={setShowUploadModal}
          portalId={portalId}
          onUploadComplete={handleUploadComplete}
          parentId={document.parent.id}
          requestedSignatureDocumentId={document.id}
          estateWorkItemId={document.estateWorkItemId!}
        />
      )}

      <MailDocumentModal showModal={showMailDocumentModal} setShowModal={setShowMaiDocumentModal} />
    </div>
  );
};

export default ResolveDocumentForSignatureButton;
